import { format, subMonths } from 'date-fns';

export const getLocalTimeZone = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timezone;
};

export const getLast12Months = () => {
  const months = [];
  const date = new Date();
  for (let i = 0; i < 12; i++) {
    months.push({
      value: format(subMonths(date, i), 'yyyy-MM'),
      label: format(subMonths(date, i), 'MMM yyyy'),
    });
  }
  return months;
};
